export { default as amountAllocate } from './amountAllocate';
